import { colors } from "@/styles/colors"

const COLORS = {
	base: {
		black: "#000000",
		white: "#FFFFFF"
	},
	system: {
		...colors
	},
	warning: {
		50: colors.yellow[50],
		100: colors.yellow[100],
		200: colors.yellow[200],
		300: colors.yellow[300],
		400: colors.yellow[400],
		500: colors.yellow[500],
		600: colors.yellow[600],
		700: colors.yellow[700],
		800: colors.yellow[800],
		900: colors.yellow[900]
	},
	bot: {
		actions: {
			100: colors.gray[100],
			150: colors.gray[200],
			500: colors.red[500],
			600: colors.red[600],
			700: colors.red[700]
		},
		activeCampaign: {
			100: colors.gray[100],
			150: colors.gray[200],
			500: colors.blue[500],
			600: colors.blue[600],
			700: colors.blue[700]
		},
		attendance: {
			100: colors.gray[100],
			150: colors.gray[200],
			500: colors.blue[500],
			600: colors.blue[600],
			700: colors.blue[700]
		},
		conditional: {
			100: colors.gray[100],
			150: colors.gray[200],
			500: colors.blue[500],
			600: colors.blue[600],
			700: colors.blue[700]
		},
		messages: {
			100: colors.gray[100],
			150: colors.gray[200],
			500: colors.green[500],
			600: colors.green[600],
			700: colors.green[700]
		}
	},
	tags: {
		tag1: "#F44336",
		tag2: "#E91E63",
		tag3: "#9C27B0",
		tag4: "#673AB7",
		tag5: "#3F51B5",
		tag6: "#2196F3",
		tag7: "#03A9F4",
		tag8: "#00BCD4",
		tag9: "#009688",
		tag10: "#4CAF50",
		tag11: "#8BC34A",
		tag12: "#CDDC39",
		tag13: "#FFEB3B",
		tag14: "#FFC107",
		tag15: "#FF9800",
		tag16: "#FF5722",
		tag17: "#795548",
		tag18: "#607D8B"
	},
	error: {
		50: colors.red[50],
		100: colors.red[100],
		200: colors.red[200],
		300: colors.red[300],
		400: colors.red[400],
		500: colors.red[500],
		600: colors.red[600],
		700: colors.red[700],
		800: colors.red[800],
		900: colors.red[900]
	},
	info: {
		100: colors.blue[100],
		200: colors.blue[200],
		300: colors.blue[300],
		400: colors.blue[400],
		500: colors.blue[500],
		600: colors.blue[600],
		700: colors.blue[700],
		800: colors.blue[800],
		900: colors.blue[900]
	},
	neutral: {
		50: colors.gray[50],
		100: colors.gray[100],
		200: colors.gray[200],
		300: colors.gray[300],
		400: colors.gray[400],
		500: colors.gray[500],
		600: colors.gray[600],
		700: colors.gray[700],
		800: colors.gray[800],
		900: colors.gray[900]
	},
	primary: {
		50: colors.purple[50],
		100: colors.purple[100],
		200: colors.purple[200],
		300: colors.purple[300],
		400: colors.purple[400],
		500: colors.purple[500],
		600: colors.purple[600],
		700: colors.purple[700],
		800: colors.purple[800],
		900: colors.purple[900]
	},
	quaternary: {
		50: colors.purple[50],
		100: colors.purple[100],
		200: colors.purple[200],
		300: colors.purple[300],
		400: colors.purple[400],
		500: colors.purple[500],
		600: colors.purple[600],
		700: colors.purple[700],
		800: colors.purple[800],
		900: colors.purple[900]
	},
	secondary: {
		100: colors.purple[200],
		150: colors.purple[300],
		500: colors.yellow[500],
		600: colors.yellow[600],
		700: colors.yellow[700]
	},
	success: {
		50: colors.green[50],
		100: colors.green[100],
		200: colors.green[200],
		300: colors.green[300],
		400: colors.green[400],
		500: colors.green[500],
		600: colors.green[600],
		700: colors.green[700],
		800: colors.green[800],
		900: colors.green[900]
	},
	tertiary: {
		50: colors.blue[50],
		100: colors.blue[100],
		200: colors.blue[200],
		300: colors.blue[300],
		400: colors.blue[400],
		500: colors.blue[500],
		600: colors.blue[600],
		700: colors.blue[700],
		800: colors.blue[800],
		900: colors.blue[900]
	}
} as const


class ThemeColors {
	readonly colors = COLORS

	getPrimaryColor(): string {
		return this.colors.primary[600]
	}

	getTextErrorColor(): string {
		return this.colors.error[700]
	}

	getTextColor(): string {
		return this.colors.neutral[900]
	}

	getDisabledColor(): string {
		return this.colors.system.gray[500]
	}

	getActionColor(): string {
		return this.colors.primary[600]
	}

	getActionHoverColor(): string {
		return this.colors.primary[700]
	}

	getTextLinkColor(): string {
		return this.colors.info[400]
	}

	getTextAlert(): string {
		return this.colors.warning[400]
	}
}

export const themeColors = new ThemeColors()